const features = [
  {
    icon: 'ri-stack-line',
    title: '多平台聚合',
    desc: '整合红桃视频、樱桃视频、茄子视频、糖心视频等热门平台，一个入口看遍全网精彩内容',
  },
  {
    icon: 'ri-speed-up-line',
    title: '不缓冲播放',
    desc: '采用智能CDN加速与多线路自动切换技术，保证高清视频流畅播放不卡顿',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '各大平台最新电视剧、综艺、短剧每日自动同步，新片上线第一时间通知',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全设备适配',
    desc: '电脑、平板、手机多终端访问，随时随地打开即看，无需下载任何APP',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    desc: '所有收录平台经人工审核，杜绝恶意跳转与弹窗广告，营造纯净观看环境',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-900 mb-3">
            为什么选择桔子视频
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            五大核心优势，打造极致视频浏览体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((item, i) => (
            <div
              key={i}
              className="group p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 text-center"
              style={{ animationDelay: `${i * 100}ms`, animationFillMode: 'both' }}
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${item.icon} text-2xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}